import React, { useEffect, useRef, useState } from "react";

const DISABLE_LAZY_LOADING = true;

const LazyImage = ({ src, alt, className = "", style = {} }) => {
  const [isLoaded, setIsLoaded] = useState(DISABLE_LAZY_LOADING);
  const imgRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    if (DISABLE_LAZY_LOADING) return; // Skip lazy loading if disabled

    const imgElement = imgRef.current;
    if (!imgElement) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          imgElement.style.filter = "blur(10px)";
          imgElement.src = src;
          observerRef.current.unobserve(imgElement);
        }
      },
      { rootMargin: "50px", threshold: 0.1 }
    );

    observerRef.current.observe(imgElement);

    return () => {
      if (observerRef.current && imgElement) {
        observerRef.current.unobserve(imgElement);
      }
    };
  }, [src]);

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "500px",
        overflow: "hidden",
      }}
    >
      <img
        ref={imgRef}
        src={DISABLE_LAZY_LOADING ? src : undefined} // Load immediately if disabled
        alt={alt}
        className={className}
        style={{
          ...style,
          display: "block",
          width: "100%",
          height: "auto",
          objectFit: "cover",
          transition: "filter 0.7s ease-out",
          filter: isLoaded ? "blur(0)" : "blur(10px)",
        }}
        onLoad={() => setTimeout(() => setIsLoaded(true), 50)}
      />
    </div>
  );
};

export default LazyImage;
